const ETAT_PUR_BRAND_NAME = 'Etat Pur';

const stripHtml = (value: string) =>
  value
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

type ProductAltData = {
  series?: string;
  name: string;
  brand?: string;
  subtitle?: string;
};

/** Alt превью товара в каталоге — как название в карточке */
export const getProductCatalogAlt = ({
  series,
  name,
  brand
}: ProductAltData) => {
  if (brand === ETAT_PUR_BRAND_NAME) {
    return stripHtml(name);
  }

  return stripHtml(`${series ?? ''} ${name}`.trim());
};

/** Текст H1 товара на PDP */
export const getProductH1 = ({
  series,
  name,
  brand,
  subtitle
}: ProductAltData) =>
  [series, stripHtml(name), brand, stripHtml(subtitle ?? '')]
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

export const getProductGalleryAlt = (
  h1: string,
  index: number,
  photoLabel: string
) =>
  index === 0 ? `${h1}, ${photoLabel}` : `${h1}, ${photoLabel} ${index + 1}`;

export const getProductThumbAlt = (
  h1: string,
  index: number,
  thumbLabel: string
) => (index === 0 ? `${h1} ${thumbLabel}` : `${h1} ${thumbLabel} ${index + 1}`);

export const stripHtmlText = stripHtml;
